<template>
    <g>
        <rect rx="3" :x="posX" :y="hoveredElement.y-30" :width="infoWidth" height="20" :class="ColorMap[hoveredElement.bgColor].fill"></rect>
        <text :x="posX + 5" :y="hoveredElement.y-16" font-family="Verdana" font-size="13" fill="white">€ {{formatEuro(hoveredElement.value, kerncijfersStore.hasMillions)}}</text>
    </g>
</template>

<script lang="ts">
    import {defineComponent} from "vue";
    import { ColorMap, HoveredElement} from "./types";
    import {useKerncijfersStore} from "./store";

    export default defineComponent({
        name: 'node-info',
        props: {
            hoveredElement: {
                type: Object as () => HoveredElement,
                required: true
            }  
        },
        data() {
            return {
                kerncijfersStore: useKerncijfersStore(),
                show: false,
                ColorMap
            }
        },
        computed: {
            infoWidth(): number {
                return (this.amountOfExtraCharacters + this.valueLength) * 8;
            },
            valueLength(): number {
                return this.hoveredElement.value.toString().length;
            },
            amountOfExtraCharacters(): number {
                return Math.floor(Math.log10(Math.abs(this.hoveredElement.value)) / 3) + 3;
            },
            offsetX(): number {
                return (this.infoWidth / 2) * -1;
            },
            posX(): number {
                return this.hoveredElement.x + this.offsetX;
            }
        },
        methods: {
            formatEuro(value: number, hasMillions: boolean) {
                let formattedValue = value.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ');

                if (hasMillions) {
                    return formattedValue
                        .replace(/(.+)? 000 000$/, '$1 M')
                        .replace(/^(-)?(\d)00 000$/, '$10,$2 M')
                        .replace(/^(-)?(\d+)(?:\s+)?(\d)00 000$/, '$1$2,$3 M');
                }

                return formattedValue;
            }
        }
    });
</script>